import { useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { ChannelContext } from "../../context/channels";
import { channelFetcher, repostFetcher } from "../../api/requests";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useToaster } from "../../context/toaster";
import { error } from "jquery";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const RepostModal = ({
  userId,
  videoId,
  channelId,
  userHasReposted,
  setUserHasReposted,
  setVideo,
}) => {
  const [loading, setloading] = useState(false);
  const [values, setValues] = useState({
    channel: null,
    original_post_id: Number(videoId),
    new_caption: "",
    published_date: new DateObject({
      calendar: persian,
      locale: persian_fa,
    }).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  });
  const [showChannelDropdown, setShowChannelDropdown] = useState(false);
  const { userChannels } = useContext(ChannelContext);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [channelSearch, setChannelSearch] = useState("");
  const baseChannels = userChannels?.results?.filter(
    (item) => item.id !== Number(channelId)
  );
  const { addMessage } = useToaster();
  const history = useHistory();

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleChannelSearch = async (value) => {
    if (!userId) return;

    setChannelSearch(value);
    if (!value.trim()) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const res = await channelFetcher.searchUserChannels(
        userId,
        channelSearch
      );
      setSearchResults(
        res.results.filter((item) => item.id !== Number(channelId))
      );
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setIsSearching(false);
    }
  };

  const handleDateChange = (value) => {
    setValues({
      ...values,
      published_date: value.toString().replace(/\//g, "-"),
    });
  };

  const handleRepost = async () => {
    if (videoId && userId) {
      try {
        const res = await repostFetcher.post(values);

        setUserHasReposted(true);
        setVideo((prevVideo) => ({
          ...prevVideo,
          counted_repost: prevVideo.counted_repost + 1,
        }));

        if (res?.id) showToast("success", "پست با موفقیت بازنشر شد.");
      } catch (err) {
        console.error(err);

        const nonFieldError = err.response.data?.non_field_errors?.[0];
        const channelError = err.response.data?.channel?.[0];

        let message = "";

        if (nonFieldError) {
          message = nonFieldError.includes("یکتا")
            ? "پست قبلا در این کانال بازنشر شده است."
            : nonFieldError;
        } else if (channelError) {
          message = channelError;
        } else {
          message = "خطایی رخ داده است.";
        }

        showToast("error", message);
      }
    } else {
      history.push("/auth/login/");
    }
  };

  return (
    <div className="p-2" style={{ width: "50rem" }}>
      {/* CHANNEL SELECT */}
      <Form.Group
        as={Col}
        style={{
          marginBottom: "15px",
          position: "relative",
        }}
      >
        <Form.Label>کانال</Form.Label>

        <div
          style={{
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#fff",
            cursor: "pointer",
            padding: "6px 8px",
            fontSize: "13px",
          }}
          onClick={() => setShowChannelDropdown(!showChannelDropdown)}
        >
          {values.channel
            ? baseChannels.find((c) => c.id == values.channel)?.name +
              ` (ID: ${values.channel})`
            : "یک کانال انتخاب کنید"}
        </div>

        {showChannelDropdown && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: "0 0 4px 4px",
              maxHeight: "220px",
              overflowY: "auto",
              zIndex: 1000,
            }}
          >
            {/* Search */}
            <input
              type="text"
              placeholder="جستجو بر اساس نام"
              value={channelSearch}
              onChange={(e) => handleChannelSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "6px 8px",
                border: "none",
                borderBottom: "1px solid #eee",
                fontSize: "13px",
              }}
            />

            {/* Items */}
            {isSearching ? (
              <div style={{ padding: "6px 8px" }}>در حال جستجو...</div>
            ) : searchResults.length > 0 ? (
              searchResults.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    setValues({ ...values, channel: item.id });
                    setShowChannelDropdown(false);
                  }}
                  style={{
                    padding: "6px 8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    background:
                      values.channel == item.id ? "#f0f0f0" : "transparent",
                    borderBottom: "1px dashed #ddd",
                  }}
                >
                  {item.name}{" "}
                  <span style={{ color: "green" }}>(ID: {item.id})</span>
                </div>
              ))
            ) : baseChannels?.length > 0 ? (
              baseChannels.map((item) => (
                <div
                  key={item.id}
                  onClick={() => {
                    setValues({ ...values, channel: item.id });
                    setShowChannelDropdown(false);
                  }}
                  style={{
                    padding: "6px 8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    background:
                      values.channel == item.id ? "#f0f0f0" : "transparent",
                    borderBottom: "1px dashed #ddd",
                  }}
                >
                  {item.name}{" "}
                  <span style={{ color: "green" }}>(ID: {item.id})</span>
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: "6px 8px",
                  fontSize: "13px",
                  color: "#888",
                }}
              >
                نام کانال مورد نظر خود را سرچ کنید
              </div>
            )}
          </div>
        )}
      </Form.Group>

      {/* CAPTION */}
      <Form.Group
        as={Col}
        style={{
          marginBottom: "15px",
        }}
      >
        <Form.Label>توضیحات</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={values.new_caption}
          onChange={(e) =>
            setValues({ ...values, new_caption: e.target.value })
          }
          style={{ fontSize: "13px" }}
          placeholder="توضیحات..."
        />
      </Form.Group>

      {/* DATE PICKER */}
      <Form.Group className="mr-3" style={{ marginBottom: "20px" }}>
        <Form.Label className="ml-2">تاریخ انتشار</Form.Label>
        <DatePicker
          onChange={handleDateChange}
          format="YYYY/MM/DD HH:mm:ss"
          calendar={persian}
          locale={persian_fa}
          calendarPosition="bottom-right"
        />
      </Form.Group>

      <Button
        variant="success"
        type="button"
        style={{
          width: "fit-content",
          fontSize: "16px",
          padding: "2px 8px",
          borderRadius: "2px",
        }}
        onClick={handleRepost}
        className="mr-3"
      >
        {loading ? "در حال ارسال..." : "ذخیره"}
      </Button>
    </div>
  );
};

export default RepostModal;
